import LocalizedStrings from 'react-localization';

import EN from './en.json';
import TR from './tr.json';
import FR from './fr.json';


const lang = new LocalizedStrings({EN,FR,TR});

export default lang;